<template>
  <highcharts class="fit-highchart" :options="options" style="width: 100%" />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { lineOptions } from '@/constants/chart-options';

export default {
  name: 'WSummaryLineColumnChart',
  props: {
    series: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      options: cloneDeep(lineOptions),
    };
  },
  watch: {
    series(value) {
      this.options.chart.height = '140px';
      this.options.series = value;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/SummaryLineColumnChart.vue